module.exports = __webpack_public_path__ + "static/media/font-awesome.14a97152.svg";